import { FirebaseApp, initializeApp } from 'firebase/app';
import { Auth, connectAuthEmulator, getAuth } from 'firebase/auth';

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string | undefined,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined,
  appId: import.meta.env.VITE_FIREBASE_APP_ID as string | undefined,
};

export const firebaseConfigured = !!(config.apiKey && config.projectId);

let app: FirebaseApp | undefined;
let auth: Auth | undefined;

/** Admin console: Google sign-in through Firebase Auth; ID tokens auto-refreshed by the SDK. */
export function firebaseAuth(): Auth | undefined {
  if (!firebaseConfigured) return undefined;
  if (!auth) {
    app = initializeApp(config);
    auth = getAuth(app);
    const emulator = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR as string | undefined;
    if (emulator) connectAuthEmulator(auth, emulator, { disableWarnings: true });
  }
  return auth;
}
